import { useEffect } from 'react';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { updateSEO } from '../../../utils/seo';

// ===== 通信教育プログラム ページ 全面最新化（Implementer B スコープ） =====
// デザイン土台（型正典）: src/pages/about/overview/page.tsx / src/pages/home/page.tsx（紺#1a2942 / 真鍮金#a38e65 /
//   金差し色#d7b779 / BTN-08 2状態 / 金eyebrow→金差し色見出し→真鍮短罫 / リード3行+ / 装飾ディバイダー禁止）。
// 旧実装のタブ切替（useState）は撤去し、静的なエディトリアル・セクションへ再構成。
// 事実正典（創作禁止・実データ変更禁止・出典path記録）:
//   [S-cur] 旧 src/pages/qualifications/distance-learning/page.tsx（特徴・基本/専門資格・料金・フローの実データ）
//   [S-canon] mng-thebutler/00_事業説明.md L63（三段階資格）
//   [S-overview] src/pages/about/overview/page.tsx（BTN08・セクション文法）

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

const features = [
  { no: '01', en: 'Own Pace', ja: '自分のペースで学習', d: '決められた通学日はありません。ご自身の生活リズムに合わせ、無理なく学びを進められます。' },
  { no: '02', en: 'While Working', ja: '仕事を続けながら', d: '働きながら、家庭を大切にしながら取得できます。学びと暮らしを両立できる設計です。' },
  { no: '03', en: 'Nationwide', ja: '全国どこからでも', d: '通信教育のため、地域を問わず受講可能。お住まいの場所にかかわらず学べます。' },
  { no: '04', en: 'One Year', ja: '申込から1年以内に提出', d: '試験は申込から1年以内の提出でかまいません。準備が整ってから、落ち着いて挑戦できます。' },
];

const basicCourses = [
  { roman: 'I', name: 'Associate Butler', ja: 'アソシエイト・バトラー', level: '初級', price: '48,000', text: '約100頁', term: '2〜4ヶ月', prereq: 'なし', href: '/qualifications/associate-butler' },
  { roman: 'II', name: 'Professional Butler', ja: 'プロフェッショナル・バトラー', level: '中級', price: '78,000', text: '約200頁', term: '4〜6ヶ月', prereq: 'Associate 保持', href: '/qualifications/professional-butler' },
  { roman: 'III', name: 'Master Butler', ja: 'マスター・バトラー', level: '上級', price: '128,000', text: '約300頁', term: '6〜8ヶ月', prereq: 'Professional 保持', href: '/qualifications/master-butler' },
];

const specialtyGroups: { label: string; price: string; items: { name: string; ja: string; href: string; desc: string; isNew?: boolean }[] }[] = [
  {
    label: '通常専門資格', price: '58,000',
    items: [
      { name: 'Dining Coordinator', ja: 'ダイニング・コーディネーター', href: '/qualifications/dining-coordinator', desc: '食事サービスの専門技能。テーブルセッティングから料理の提供まで。' },
      { name: 'Travel Concierge', ja: 'トラベル・コンシェルジュ', href: '/qualifications/travel-concierge', desc: '旅行コーディネートの専門技能。計画から現地サポートまで。' },
      { name: 'Business Manner', ja: 'ビジネス・マナー', href: '/qualifications/business-manner', desc: '執事流ビジネスマナーと国際儀礼の専門技能。' },
    ],
  },
  {
    label: '執事知識資格', price: '38,000',
    items: [
      { name: 'Afternoon Tea', ja: 'アフタヌーン・ティー', href: '/qualifications/afternoon-tea', desc: 'アフタヌーンティーの文化とマナー。英国式の正統なサービス。', isNew: true },
      { name: 'Tea Sommelier', ja: 'ティー・ソムリエ', href: '/qualifications/tea-sommelier', desc: '紅茶の専門知識。茶葉の選び方から淹れ方まで。', isNew: true },
      { name: 'Butler Style & Uniform', ja: 'バトラー・スタイル＆ユニフォーム', href: '/qualifications/butler-style-uniform', desc: '執事の装いと美学。品格ある装いの知識。', isNew: true },
    ],
  },
];

const included = [
  '専用テキスト教材（冊子）', 'オンライン動画レッスン（視聴期間1年）', '実技練習用キット', '認定試験問題・解答用紙',
  '試験添削サービス', '合格時：認定証・認定カード発行', '執事サロン3時間無料体験（30,000円相当）', '送料込み',
];

const flow = [
  { n: '1', t: 'お申込み', d: '専用フォームからお申込み。お振込確認後、教材を発送します。' },
  { n: '2', t: '教材到着・学習開始', d: 'テキスト、練習キット、動画視聴用アクセスコード、執事サロン無料券が届きます。' },
  { n: '3', t: '試験問題に挑戦', d: '準備ができたら試験問題に解答。解答用紙を返送（申込から1年以内）。' },
  { n: '4', t: '合否判定', d: '80点以上で合格。合格者には認定証と認定カードを発行。' },
  { n: '5', t: '資格取得完了', d: '認定証到着で資格取得完了。履歴書に記載できます（有効期限なし）。' },
];

const notes = [
  '本資格は全日本執事協会が認定する民間資格です',
  '資格取得により就職・転職・収入を保証するものではありません',
  '知識習得と自己研鑽を目的とした学習プログラムです',
  '実際の就業には各雇用先の採用基準に従ってください',
  '再試験料：15,000円（不合格の場合、1年以内なら何度でも再挑戦可能）',
];

function SecHead({ roman, en, children }: { roman?: string; en: string; children: React.ReactNode }) {
  return (
    <div className="mb-9">
      <div className="-mx-5 sm:-mx-8 mb-6 bg-[#1a2942] border-y border-[#a38e65]/25 px-5 sm:px-8 py-[18px]">
        <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.28em] text-xs text-[#d7b779]">{roman ? `${roman}. ` : ''}{en}</span>
      </div>
      <h2 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[31px] leading-[1.5] tracking-[0.02em]">{children}</h2>
    </div>
  );
}

export default function DistanceLearning() {
  useEffect(() => {
    updateSEO({
      title: '執事資格の通信教育プログラム｜自宅で学ぶ執事検定 | 全日本執事協会',
      description: '全日本執事協会の公式通信教育プログラム。基本資格（Associate・Professional・Master）から専門資格まで、すべて自宅で学べます。仕事や家庭と両立しながら、自分のペースで確実に資格取得。全資格に執事サロン3時間無料体験（30,000円相当）付き、申込から1年以内に試験提出。',
      keywords: '執事 通信教育,執事資格 自宅学習,通信講座,執事検定,Associate Butler,全日本執事協会',
      canonical: 'https://butler-association.jp/qualifications/distance-learning',
    });
  }, []);

  const breadcrumbs = [
    { label: 'ホーム', href: '/' },
    { label: '執事資格制度', href: '/qualifications' },
    { label: '通信教育プログラム' },
  ];

  return (
    <Layout>
      {/* ===== ヒーロー：全幅ビルボード。由来: overview ヒーロー文法 ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[520px] lg:min-h-[600px] flex items-center">
        <img
          src="/images/generated/jba-p-020-qual-distance-v2.webp"
          alt="通信教育プログラム。自宅で学ぶ執事資格取得への道"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.93)_0%,rgba(16,20,26,0.74)_48%,rgba(16,20,26,0.36)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1200px] mx-auto px-5 sm:px-8 pt-32 pb-16 lg:pt-36 lg:pb-20">
          <div className="max-w-[700px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Distance Learning</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(28px,3.4vw,44px)] leading-[1.4] tracking-[0.04em] mb-6">
              <span className="block">通信教育プログラム</span>
              <span className="block text-[#d7b779] text-[clamp(20px,2.4vw,30px)] mt-2">自宅で学ぶ、執事資格取得への道</span>
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95]">
              仕事や家庭の都合で通学が難しいかたでも、ご自身のペースで着実に学習を進められる、全日本執事協会の公式通信教育プログラムです。充実した教材と手厚いサポートで、確実な資格取得をお手伝いします。
            </p>
          </div>
        </div>
      </section>

      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      <div className="bg-white">
        <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-14 sm:py-18 lg:py-20 space-y-16 sm:space-y-20">

          {/* --- I. 概要 + 細罫スタッツ。由来: overview S1 --- */}
          <section>
            <SecHead en="About the Program">通学せずに、<span className="text-[#a38e65]">確かに学ぶ</span></SecHead>
            <div className="grid lg:grid-cols-[1fr_300px] gap-8 lg:gap-12 items-start">
              <div className="space-y-[18px] font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95]">
                <p>当協会の通信教育プログラムは、執事として必要な知識とスキルを、自宅で体系的に学習できるよう設計されています。基本資格から専門資格まで、あなたのキャリア目標に合わせて最適な学習コースを選べます。</p>
                <p>テキスト教材とオンライン動画レッスンを組み合わせ、実技も含めてわかりやすく学べる構成です。試験も自宅で受けられる通信試験のため、通学の負担なく資格取得を目指せます。</p>
                <p>全資格に、お台場の執事サロン3時間無料体験（30,000円相当）が付きます。申込から1年以内の試験提出で、ご自身のペースで確実な資格取得を実現します。</p>
              </div>
              <dl className="lg:pt-1 border-t border-[#e2ddd2] pt-5 space-y-4">
                <div className="flex items-baseline justify-between">
                  <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em]">受講場所</dt>
                  <dd className="font-['Noto_Serif_JP',serif] text-lg text-[#1a2942]">全国どこでも</dd>
                </div>
                <div className="flex items-baseline justify-between border-t border-[#e2ddd2] pt-4">
                  <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em]">試験提出</dt>
                  <dd className="font-['Playfair_Display',serif] text-2xl text-[#1a2942]">1<span className="text-sm text-[#8f7a56] ml-1">年以内</span></dd>
                </div>
                <div className="flex items-baseline justify-between border-t border-[#e2ddd2] pt-4">
                  <dt className="font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em]">共通特典</dt>
                  <dd className="font-['Noto_Serif_JP',serif] text-base text-[#1a2942]">サロン3時間無料</dd>
                </div>
              </dl>
            </div>
          </section>

          {/* --- II. 通信教育の特徴（番号付き2カラムブロック型）。由来: overview S4 --- */}
          <section>
            <SecHead roman="I" en="Why Distance Learning">通信教育で学ぶ、<span className="text-[#a38e65]">四つの理由</span></SecHead>
            <div className="grid sm:grid-cols-2 gap-x-10 gap-y-8">
              {features.map((f) => (
                <div key={f.no} className="flex gap-5 border-t border-[#e2ddd2] pt-6">
                  <span className="font-['Playfair_Display',serif] text-[#d7b779] text-3xl leading-none shrink-0 pt-1">{f.no}</span>
                  <div>
                    <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1">{f.en}</span>
                    <h3 className="jba-display font-medium text-[#1a2942] text-lg mb-2 leading-[1.5]">{f.ja}</h3>
                    <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{f.d}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* --- III. 基本資格コース（階梯ステッパー）= 新バリエーション①
               由来注記: overview S5 タイムライン＋S4 番号ブロックを合流させた資格ステッパー（一覧ページと同系・本ページは料金/要項を横並べ）。 --- */}
          <section>
            <SecHead roman="II" en="Core Courses">基本資格コース、<span className="text-[#a38e65]">三段階</span></SecHead>
            <p className="font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl mb-9">
              執事の総合力を段階的に証明する三段階の基本資格です。初級から上級へ、飛び級はできません。まずは Associate Butler から、着実に歩みを進めます。
            </p>
            <ol className="border-t border-[#e2ddd2]">
              {basicCourses.map((c) => (
                <li key={c.name} className="border-b border-[#e2ddd2]">
                  <a href={c.href} className="flex flex-wrap items-center gap-x-6 gap-y-2.5 px-2 sm:px-4 py-5 group hover:bg-[#f8f6f0] transition-colors duration-300">
                    <span className="font-['Playfair_Display',serif] text-2xl text-[#a38e65] w-8 shrink-0">{c.roman}</span>
                    <div className="min-w-[220px]">
                      <span className="block jba-display text-[#1a2942] text-lg">{c.name}</span>
                      <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mt-0.5">{c.ja}・{c.level}</span>
                    </div>
                    <dl className="flex flex-wrap gap-x-6 gap-y-1">
                      {[['テキスト', c.text], ['期間', c.term], ['受験資格', c.prereq]].map(([k, v]) => (
                        <div key={k} className="flex items-baseline gap-1.5">
                          <dt className="font-['Noto_Serif_JP',serif] text-[11px] text-[#8f7a56]">{k}</dt>
                          <dd className="font-['Noto_Serif_JP',serif] text-[13px] text-[#1a2942]">{v}</dd>
                        </div>
                      ))}
                    </dl>
                    <span className="jba-display text-xl text-[#1a2942] ml-auto">{c.price}<span className="text-xs text-[#8f7a56] ml-1">円</span></span>
                    <span className="font-['Noto_Serif_JP',serif] text-sm text-[#a38e65] shrink-0 group-hover:translate-x-1 transition-transform">詳細を見る →</span>
                  </a>
                </li>
              ))}
            </ol>
          </section>

          {/* --- IV. 専門資格コース（エディトリアルリスト）= 新バリエーション②。由来注記: overview S4 を料金帯グループの行リストへ翻案 --- */}
          <section>
            <SecHead roman="III" en="Specialized Courses">専門資格コース、<span className="text-[#a38e65]">分野を極める</span></SecHead>
            <p className="font-['Noto_Serif_JP',serif] text-base text-[#333] leading-[1.95] max-w-3xl mb-9">
              特定分野の専門知識を証明する資格も、すべて通信教育で取得できます。基本資格と組み合わせることで、対応できる場面が大きく広がります。
            </p>
            <div className="space-y-10">
              {specialtyGroups.map((g) => (
                <div key={g.label}>
                  <div className="flex items-baseline gap-4 mb-4 pb-3 border-b border-[#e2ddd2]">
                    <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl">{g.label}</h3>
                    <span className="jba-display text-[#a38e65] text-xl">{g.price}<span className="text-xs text-[#8f7a56] ml-0.5">円</span></span>
                  </div>
                  <ul>
                    {g.items.map((it) => (
                      <li key={it.href} className="border-b border-[#e2ddd2] last:border-b-0">
                        <a href={it.href} className="flex flex-wrap items-center gap-x-5 gap-y-1.5 py-4 group hover:bg-[#f8f6f0] transition-colors duration-300 -mx-2 px-2">
                          <div className="min-w-[220px]">
                            <span className="jba-display text-[#1a2942] text-base sm:text-lg">{it.name}
                              {it.isNew && <span className="ml-2 align-middle font-['Playfair_Display',serif] text-[10px] tracking-[0.14em] text-[#8f7a56] border border-[#a38e65]/50 px-1.5 py-0.5">NEW</span>}
                            </span>
                            <span className="block font-['Noto_Serif_JP',serif] text-[11px] text-[#8f7a56] tracking-[0.06em] mt-0.5">{it.ja}</span>
                          </div>
                          <p className="flex-1 min-w-[240px] font-['Noto_Serif_JP',serif] text-[13px] text-[#4a4638] leading-[1.8]">{it.desc}</p>
                          <span className="font-['Noto_Serif_JP',serif] text-sm text-[#a38e65] shrink-0 group-hover:translate-x-1 transition-transform">詳細を見る →</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>

          {/* --- V. 料金に含まれるもの（細罫チェックリスト）。由来: overview S2 罫線dl の一覧版 --- */}
          <section>
            <SecHead roman="IV" en="What's Included">料金に、<span className="text-[#a38e65]">すべて含まれます</span></SecHead>
            <ul className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 border-t-2 border-[#1a2942]">
              {included.map((x) => (
                <li key={x} className="flex items-start gap-2.5 border-b border-[#e2ddd2] py-4">
                  <span className="text-[#a38e65] text-[13px] leading-none pt-1" aria-hidden="true">◆</span>
                  <span className="font-['Noto_Serif_JP',serif] text-[14px] text-[#1a2942] leading-[1.7]">{x}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* --- VI. 資格取得の流れ（縦タイムライン細罫型）= 新バリエーション③。由来注記: overview S5 タイムライン文法 --- */}
          <section>
            <SecHead roman="V" en="How to Apply">資格取得までの、<span className="text-[#a38e65]">5ステップ</span></SecHead>
            <ol className="relative border-l border-[#e2ddd2] ml-1 max-w-3xl">
              {flow.map((s) => (
                <li key={s.n} className="relative pl-7 sm:pl-9 pb-8 last:pb-0">
                  <span className="absolute -left-[6px] top-1 w-[11px] h-[11px] rounded-full bg-[#a38e65] ring-4 ring-white"></span>
                  <div className="flex items-baseline gap-3 mb-1.5">
                    <span className="font-['Playfair_Display',serif] text-xl text-[#1a2942]">{s.n}</span>
                    <span className="jba-display font-medium text-[#1a2942] text-base sm:text-lg">{s.t}</span>
                  </div>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{s.d}</p>
                </li>
              ))}
            </ol>
          </section>

          {/* --- VII. ご確認ください（注意事項） --- */}
          <section>
            <SecHead en="Please Note">ご確認ください</SecHead>
            <ul className="border-t border-[#e2ddd2] max-w-3xl">
              {notes.map((n) => (
                <li key={n} className="flex items-start gap-3 border-b border-[#e2ddd2] py-4">
                  <span className="text-[#a38e65] text-[13px] leading-none pt-1.5" aria-hidden="true">◆</span>
                  <span className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.85]">{n}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* --- VIII. 締めCTA（紺パネル）。由来: overview S6 --- */}
          <section>
            <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 lg:p-12">
              <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.24em] text-[11px] text-[#d7b779] mb-3">Next Steps</span>
              <h2 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] mb-5">あなたに最適な資格を、ご一緒に</h2>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#e7e2d8] leading-[1.95] max-w-3xl mb-8">
                キャリア目標や関心のある分野に応じて、最適な資格取得プランをご提案します。まずは資格制度の全体像もあわせてご覧ください。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                <a href="/qualifications" className={BTN08_ON_NAVY}>資格制度の一覧を見る</a>
                <a href="/contact" className={BTN08_ON_NAVY}>お問い合わせ・相談する</a>
              </div>
            </div>
          </section>

        </div>
      </div>
    </Layout>
  );
}
